<template>
  <div>
    <div v-if="loading" class="flex flex-col items-center justify-center gap-2 mt-[200px]">
      <CustomLoader :size="28" />
    </div>
    <div v-else>
      <div v-if="billingVersion === 'v1'">You are using the old billing version. Please upgrade to the new version.</div>
      <ManageBillingV1 v-if="billingVersion === 'v2'" />
      <ManageBillingV3 v-if="billingVersion === 'v3'" />
      <ManageBillingV4 v-if="billingVersion === 'v4'" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import ManageBillingV1 from '@/views/ManageBillingV1.vue';
import ManageBillingV3 from '@/views/ManageBillingV3.vue';
import ManageBillingV4 from '@/views/ManageBillingV4.vue';
import CustomLoader from '@/components/custom/CustomLoader.vue';
import DashboardService from '@/services/DashboardService';

const loading = ref(true);
const billingVersion = ref('v3');
const fetchVersion = async () => {
  try {
    const response = await DashboardService.getBillingVersion();
    if (response?.version) {
      billingVersion.value = response.version;
    }
  } catch (error) {
    console.error('Error fetching billing version:', error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchVersion();
});
</script>

<style scoped>
.custom_container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 10px;
  border: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-2);
  font-family: 'Proxima Nova', sans-serif;
}
</style>
